<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
  styleClass="send-password-link-dialog"
  position="center"
  (onHide)="onHide()">

  <ng-template pTemplate="header">
    <span class="send-password-link-dialog__title">{{ header }}</span>
  </ng-template>

  <div class="send-password-link-dialog__body">
    <p class="send-password-link-dialog__status">
      “{{ userName || defaultUserName }}” does not have an email address configured.
    </p>
    <p class="send-password-link-dialog__instruction">
      An email is required to send the password link. Enter an email below to save it to this {{ profileLabel }} profile and send the link.
    </p>

    <form [formGroup]="emailForm" class="send-password-link-dialog__form" (ngSubmit)="saveAndSend()">
      <label class="send-password-link-dialog__label" for="send-password-link-email">
        Email <span class="required-asterisk">*</span>
      </label>

      <span class="p-input-icon-right w-full">
        <i
          class="pi"
          [ngClass]="showEmail ? 'pi-eye-slash' : 'pi-eye'"
          (click)="toggleEmailVisibility()"
          role="button"
          tabindex="0"
          [attr.aria-label]="showEmail ? 'Hide email' : 'Show email'"></i>
        <input
          id="send-password-link-email"
          pInputText
          class="w-full send-password-link-dialog__input"
          formControlName="email"
          [type]="showEmail ? 'text' : 'password'"
          placeholder="Enter Email Address"
          autocomplete="email" />
      </span>

      @if (emailControl.invalid && (emailControl.dirty || emailControl.touched)) {
        <div class="send-password-link-dialog__error">
          @if (emailControl.errors?.['required']) {
            <span>Email is required.</span>
          } @else if (emailControl.errors?.['pattern']) {
            <span>Please enter a valid email address.</span>
          }
        </div>
      }
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="send-password-link-dialog__footer">
      <button
        id="send-password-link-cancel-btn"
        pButton
        appRipple
        type="button"
        class="send-password-link-dialog__cancel-btn"
        label="Cancel"
        (click)="cancel()"></button>

      <button
        id="send-password-link-dont-save-btn"
        pButton
        appRipple
        type="button"
        class="p-button-outlined send-password-link-dialog__secondary-btn"
        label="Don't Save Email & Send Link"
        [disabled]="!isEmailValid"
        (click)="sendWithoutSaving()"></button>

      <button
        id="send-password-link-save-send-btn"
        pButton
        appRipple
        type="button"
        class="send-password-link-dialog__primary-btn"
        label="Save Email & Send Link"
        [disabled]="!isEmailValid"
        (click)="saveAndSend()"></button>
    </div>
  </ng-template>
</p-dialog>
